module.exports = __webpack_public_path__ + "img/exam_jan_2025_dptic2a5.2a5a6145.jpg";